<div class="impersonation-active-alert__dialog-box" [mmTestId]="'ORDER_HISTORY.IMPERSONATION_ACTIVE_DIALOG_BOX'">
  <mm-dialog-title>
    <div class="impersonation-active-alert__dialog-header">
      <mm-icon [name]="'info'" class="impersonation-active-alert__warning-icon"></mm-icon>
      <p class="impersonation-active-alert__dialog-title">
        {{ 'PAGES.AUTH.EMPLOYEE.ORDER_HISTORY_PAGE.DIALOG.HEADING.IMPERSONATION_ACTIVE_ALERT' | translate }}
      </p>
    </div>
  </mm-dialog-title>

  <hr class="impersonation-active-alert__dialog-divider" />

  <mm-dialog-content class="impersonation-active-alert__dialog-content">
    {{ 'PAGES.AUTH.EMPLOYEE.ORDER_HISTORY_PAGE.DIALOG.BODY_TEXT.IMPERSONATION_ACTIVE_ALERT' | translate }}
  </mm-dialog-content>

  <mm-dialog-footer>
    <div class="impersonation-active-alert__dialog-footer">
      <button (click)="handleStartWithNewCustomer($event)" mm-button [color]="'secondary'"
        class="impersonation-active-alert__new-customer-btn" [mmTestTarget]="'dialog-new-customer-button'">
        {{ 'PAGES.AUTH.EMPLOYEE.SHARE_PAYMENT_LINK.DAILOG.START_WITH_NEW_CUSTOMER.BUTTON.TEXT' | translate }}
      </button>

      <button (click)="onEmployeeLogout()" mm-button [color]="'primary'" class="impersonation-active-alert__logout-btn"
        [mmTestTarget]="'dialog-logout-button'">
        {{ 'PAGES.AUTH.EMPLOYEE.SHARE_PAYMENT_LINK.DAILOG.EMPLOYEE_SIGN_OUT.BUTTON.TEXT' | translate }}
      </button>
    </div>
  </mm-dialog-footer>
</div>
